import { render, staticRenderFns } from "./StakedPools.vue?vue&type=template&id=42345d7e&scoped=true&"
import script from "./StakedPools.vue?vue&type=script&lang=js&"
export * from "./StakedPools.vue?vue&type=script&lang=js&"
import style0 from "./StakedPools.vue?vue&type=style&index=0&id=42345d7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42345d7e",
  null
  
)

export default component.exports